import React from 'react'

const DepositLocation = ({ row, isComputer }) => {
    return (
        <div className={`flex ${isComputer ? 'block w-1/4' : 'w-1/2 hidden'}`}>
            <div className="truncate">
                <i className="fas fa-map-marker-alt pr-2" />
                <span>
                    {row.depositLocation.label != null
                        ? row.depositLocation.label
                        : `${
                              row.depositLocation.street
                                  ? row.depositLocation.street + ', '
                                  : ''
                          }
                                                          ${
                                                              row
                                                                  .depositLocation
                                                                  .city
                                                          }`}
                </span>
            </div>
        </div>
    )
}

export default DepositLocation
